import { useMediaRemote } from '@vidstack/react';
import { FastForwardIcon } from 'lucide-react';
import { forwardRef, useEffect, useState } from 'react';
import { ToggleGroup, ToggleGroupItem } from '../ui/toggle-group';

const SPEEDS = ['1', '1.5', '2'];

const SpeedButtons = forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => {
    // context
    const remote = useMediaRemote();
    // state
    const [speed, setSpeed] = useState('1');
    // side effects
    useEffect(() => {
      remote?.changePlaybackRate(parseFloat(speed));
    }, [speed]);
    // UI
    return (
      <div ref={ref} className={className} {...props}>
        <div className="flex mb-2">
          <FastForwardIcon size={16} className="foreground stroke-primary" />
          <p className="ml-1 text-xs text-primary">Velocidade do áudio</p>
        </div>
        <ToggleGroup
          type="single"
          value={speed}
          onValueChange={value => {
            if (value) setSpeed(value);
          }}
        >
          {SPEEDS.map(value => (
            <ToggleGroupItem key={value} value={value} variant="transparent" className="mr-2 w-12">
              {`${value}x`}
            </ToggleGroupItem>
          ))}
        </ToggleGroup>
      </div>
    );
  }
);
SpeedButtons.displayName = 'SpeedButtons';

export default SpeedButtons;
